// extracted by mini-css-extract-plugin
export default {"cell":"OpportunityTableBody_cell__BHcJn","cell__emptyState":"OpportunityTableBody_cell__emptyState__TAB1n","emptyState":"OpportunityTableBody_emptyState__AkIyd font-sm-medium"};